import React, { useState } from 'react';
import './TestErrorComponent.css';

const TestErrorComponent = () => {
  const [shouldError, setShouldError] = useState(false);
  const [errorType, setErrorType] = useState('render');

  // 렌더링 에러 발생
  if (shouldError && errorType === 'render') {
    throw new Error('테스트용 렌더링 에러입니다!');
  }

  // 다양한 에러 타입 시뮬레이션
  const triggerError = (type) => {
    setErrorType(type);
    
    switch (type) {
      case 'render':
        setShouldError(true);
        break;
      case 'async':
        // 비동기 에러 시뮬레이션
        setTimeout(() => {
          throw new Error('테스트용 비동기 에러입니다!');
        }, 1000);
        break;
      case 'promise':
        // Promise 에러 시뮬레이션
        Promise.reject(new Error('테스트용 Promise 에러입니다!'));
        break;
      case 'network':
        // 네트워크 에러 시뮬레이션
        fetch('/non-existent-endpoint')
          .then(() => {})
          .catch(() => {
            throw new Error('테스트용 네트워크 에러입니다!');
          });
        break;
      default:
        setShouldError(true);
    }
  };

  const resetError = () => {
    setShouldError(false);
    setErrorType('render');
  };

  return (
    <div className="test-error-container">
      <div className="test-error-card">
        <h2>🧪 ErrorBoundary 테스트 컴포넌트</h2>
        <p>이 컴포넌트는 ErrorBoundary가 제대로 작동하는지 테스트하기 위한 도구입니다.</p>
        
        <div className="error-buttons">
          <h3>에러 발생 테스트</h3>
          <div className="button-group">
            <button 
              onClick={() => triggerError('render')}
              className="error-button render-error"
            >
              렌더링 에러 발생
            </button>
            <button 
              onClick={() => triggerError('async')}
              className="error-button async-error"
            >
              비동기 에러 발생
            </button>
            <button 
              onClick={() => triggerError('promise')}
              className="error-button promise-error"
            >
              Promise 에러 발생
            </button>
            <button 
              onClick={() => triggerError('network')}
              className="error-button network-error"
            >
              네트워크 에러 발생
            </button>
          </div>
        </div>

        <div className="test-info">
          <h3>테스트 방법</h3>
          <ol>
            <li>위 버튼 중 하나를 클릭하세요</li>
            <li>ErrorBoundary가 에러를 잡아 폴백 UI를 표시하는지 확인하세요</li>
            <li>콘솔에서 에러 로그를 확인하세요</li>
            <li>"새로고침" 또는 "홈으로 가기" 버튼으로 복구하세요</li>
          </ol>
        </div>

        <div className="current-state">
          <h3>현재 상태</h3>
          <p><strong>에러 상태:</strong> {shouldError ? '에러 발생' : '정상'}</p>
          <p><strong>에러 타입:</strong> {errorType}</p>
        </div>

        {shouldError && (
          <div className="reset-section">
            <button onClick={resetError} className="reset-button">
              에러 상태 리셋
            </button>
          </div>
        )}

        <div className="warning">
          <h3>⚠️ 주의사항</h3>
          <ul>
            <li>이 컴포넌트는 테스트 목적으로만 사용하세요</li>
            <li>프로덕션 환경에서는 제거해야 합니다</li>
            <li>에러 발생 시 페이지가 일시적으로 사용할 수 없게 됩니다</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default TestErrorComponent;
